const Cookies = require('js-cookie');
const Moment = require('moment');

require('./blockUI');

commonUtil = (function() {
  /**
   *
   */
  const self = {};

  /**
   *
   * @param action
   * @param queryElementId
   * @param loadingFlag
   */
  self.requestBaseUrl = function(action, queryElementId, loadingFlag) {
    if (loadingFlag) {
      self.loading();
    }
    let url = action;
    const query = document.getElementById(queryElementId);

    if (query) {
      url = `${url}?${query.value}`;
    }

    location.href = url;
  };

  /**
   * URLクエリパラメータを加工しページ遷移を行う
   *
   * @param action {string} 遷移先URL
   * @param queryElementId {string} クエリ要素のElementId
   * @param loadingFlag {boolean} ローディング表示の有無
   * @param anchorTag {string} ページ内リンク名
   * @param isOpenBlank {boolean} _blankで開く
   */
  self.requestExtendUrl = function(
    action,
    queryElementId,
    extendQuery = [],
    loadingFlag = true,
    anchorTag = '',
    isOpenBlank = false
  ) {
    if (loadingFlag) {
      self.loading();
    }
    let url = action;
    let baseQueryString = '';
    const baseQueryParams = {};
    const extendQueryParams = {};
    const query = document.getElementById(queryElementId);
    if (query) {
      const queryValues = String(query.value).split('&');
      for (const queryValue of queryValues) {
        const value = queryValue.split('=');
        // eslint-disable-next-line prefer-destructuring
        baseQueryParams[value[0]] = value[1];
      }
    }
    if (extendQuery) {
      for (const queryKey in extendQuery) {
        if (Object.prototype.hasOwnProperty.call(extendQuery, queryKey)) {
          let extendQueryValues = '';
          // スペース区切りの場合+でつなぐ
          const arrayExtendQuery = String(extendQuery[queryKey]).split(/\s/);
          if (arrayExtendQuery.length > 1) {
            arrayExtendQuery.forEach(function(value, index) {
              extendQueryValues += encodeURIComponent(value);
              if (index < arrayExtendQuery.length - 1) {
                extendQueryValues += '+';
              }
            });
          } else {
            extendQueryValues = encodeURIComponent(extendQuery[queryKey]);
          }
          extendQueryParams[queryKey] = extendQueryValues;
        }
      }
    }
    Object.assign(baseQueryParams, extendQueryParams);
    for (const key in baseQueryParams) {
      baseQueryString = `${baseQueryString}&${key}=${baseQueryParams[key]}`;
    }
    url = `${url}?${baseQueryString}`;
    if (anchorTag) {
      url = `${url}#${anchorTag}`;
    }
    if (isOpenBlank === true) {
      window.open(url, '_blank');
    } else {
      location.href = url;
    }
  };

  /**
   *
   * @param action
   * @param aryOptName
   * @param form
   */
  self.searchBaseUrl = function(action, aryOptName, form) {
    self.loading();
    const srhForm = document.getElementById(form);

    const aryOptionName = aryOptName || [];
    aryOptionName.forEach(function(optName) {
      const inputElements = document.getElementsByName(optName);

      inputElements.forEach(function(inputElement) {
        const cloneElement = inputElement.cloneNode(true);
        cloneElement.id =
          inputElement.id +
          Math.random()
            .toString(32)
            .substring(5);
        srhForm.appendChild(cloneElement);
      });
    });

    srhForm.method = 'get';
    srhForm.action = action;
    srhForm.submit();
  };

  /**
   * @param action {string} 遷移先URL
   * @param queryElementId  {string} クエリ文字列
   * @param sortId  {string} ソートする値と順番
   * @param extendQuery
   * @return {boolean}
   */
  self.requestSortUrl = function(
    action,
    queryElementId,
    extendQuery = {},
    anchorTag = ''
  ) {
    self.loading();
    let url = action;
    const query = document.getElementById(queryElementId);
    if (query) {
      url = `${url}?${query.value}`;
    }

    if (extendQuery) {
      /* eslint guard-for-in: 0 */
      for (const queryKey in extendQuery) {
        url = `${url}&${queryKey}=${encodeURIComponent(extendQuery[queryKey])}`;
      }
    }

    location.href = `${url}${anchorTag}`;
    return false;
  };

  /**
   * URLに指定したクエリを付加して遷移する
   * 削除予定（推奨：requestExtendUrl）
   */
  self.changeUrl = function(key, value) {
    self.loading();
    const url = location.href;
    const res = commonUtil.changeUrlParameter(url, key, value);
    location = res;
  };

  /**
   * URLの特定のクエリを書き換える
   * 削除予定（推奨：requestExtendUrl）
   *
   * @param url   {string} URL
   * @param key   {string} クエリのキー
   * @param value {string} クエリの値
   */
  self.changeUrlParameter = function(url, key, value) {
    if (url.slice(-1) === '&') {
      url.slice(0, -1);
    }

    const regex = new RegExp(`([?&]${key})(=([^&#]*)|&|#|$)`);

    if (regex.test(url)) {
      return url.replace(regex, `$1=${value}`);
    }

    if (location.search) {
      return `${url}&${key}=${value}`;
    }

    return `${url}?${key}=${value}`;
  };

  /**
   * hidden属性を持つInputタグを生成
   *
   * @param formId
   * @param name
   * @param value
   */
  self.addHiddenInput = function(formId, name, value) {
    const form = document.getElementById(formId);
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  /**
   * 現在のURLをパスまで取得
   *
   * @return {string}
   */
  self.getCurrentBaseUrl = function() {
    return location.origin + location.pathname;
  };

  /**
   * クエリパラメータをオブジェクトに変換(IE11対応)
   *
   * @param query
   * @return {object}
   */
  self.convQueryToObject = function(query) {
    return query.split('&').map((p) => p.split('=')).reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {});
  };

  /**
   * 特定IDを持つエレメントのvalueを変更
   *
   * @param id
   * @param value
   */
  self.changeValueById = function(id, value) {
    document.getElementById(id).value = value;
  };

  /**
   * InitialQueryのクエリを書き換える
   *
   * @param key
   * @param value
   */
  self.changeInitialQuery = function(key, value) {
    const initialQuery = document.getElementById('initialQuery').value;
    if (initialQuery.slice(-1) === '&') {
      initialQuery.slice(0, -1);
    }

    const regex = new RegExp(`([?&]${key})(=([^&#]*)|&|#|$)`);

    if (regex.test(initialQuery)) {
      document.getElementById('initialQuery').value = initialQuery.replace(
        regex,
        `$1=${value}`
      );
    }
  };

  /**
   * 月末日を取得
   *
   * @param date YYYY-MM
   * @return {string}
   */
  self.getLastDayOfMonth = function(date) {
    return Moment(date, 'YYYY-MM')
      .endOf('month')
      .format('YYYY-MM-DD');
  };

  /**
   * @param number
   * @return
   */
  self.numberFormat = function(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /**
   * 全角スペース・連続するスペースを1つの半角スペースへ置き換える
   *
   * @param {string} data    元の文字列
   */
  self.trimSpaces = function(data) {
    return data.replace(/\u{3000}/g, ' ').replace(/\s+/g, ' ');
  };

  /**
   * html文字列の強調変換.
   * <pre>
   * 変換対象文字列の中で、強調文字リストの各要素を強調表示する（対象の強調文字の前後に強調表示タグを追加）
   * 1. 任意の開始タグと終了タグに囲まれた文字列は変換対象外とする
   * 2. 強調文字の要素間で包含関係（例：「写真」、「写真集」）が存在する場合、文字数が多い強調文字を優先して強調表示する
   * </pre>
   * @param {string} value             変換対象文字列
   * @param {string} highlightWordList 強調文字リスト
   * @param {string} options           オプション
   *                                      1. 検索種別[searchType]（'match': 完全一致、'prefix': 前方一致）
   *                                      2. 強調文字プレフィックス[highlightPrefix]
   * @param {string} highlistTag       強調表示タグ
   */
  self.highlightWords = function(value,
                                   highlightWordList,
                                   options = {},
                                   highlistTag = ['<strong class="u-strong-txt">', '</strong>']) {

      let wordList = [];
      // 半角スペースによる分割
      highlightWordList.forEach(highlightWord => wordList = wordList.concat(self.trimSpaces(highlightWord).split(' ')));

      // 強調文字リストの正規化（禁止文字の削除）
      wordList = wordList.map(highlightWord => {
          return highlightWord
                      .normalize('NFKC')
                      .replace(/[^0-9A-Za-z０-９Ａ-Ｚａ-ｚぁ-ゖァ-ヾ一-鶴\\ \\々\\ヴ\r]+/g, '');
          });

      // 強調文字リストを変換
      // 1. 重複除外
      // 2. 文字数の多い順にソート
      wordList = wordList
                    .filter((value, index, self) => self.indexOf(value) === index)
                    .sort((preWord, nextWord) => nextWord.length - preWord.length);

      let retValue = value;

      // 文字列の変換
      wordList.forEach(highlightWord => {
          // 強調文字リストの要素ごとに処理を実施
          retValue = self.highlightHtml(retValue, highlightWord, options, highlistTag);
      });

      return retValue;
  };

  /**
   * html文字列の強調変換.
   * <pre>
   * 変換対象文字列の中で、強調文字の前後に強調表示タグを追加する。
   * ただし、任意の開始タグと終了タグに囲まれた文字列は変換対象外とする。
   * </pre>
   * @param {string} value         変換対象文字列
   * @param {string} highlightWord 強調文字
   * @param {string} options       オプション
   *                                    1. 検索種別[searchType]（'match': 完全一致、'prefix': 前方一致）
   *                                    2. 強調文字プレフィックス[highlightPrefix]
   * @param {array} highlistTag    強調表示タグ
   */
  self.highlightHtml = function(value, highlightWord, options, highlistTag) {

      const retHtml        = [];                                   // 戻り値
      const parsedHtml     = $.parseHTML(value.normalize('NFKC')); // 変換対象文字列をDOMノードの配列に変換
      let   highlightValue = highlightWord;

      if ('highlightPrefix' in options && options.highlightPrefix) {
          // 強調文字にプレフィックス値を追加
          highlightValue = options.highlightPrefix + highlightValue;
      }

      let highlightReg = new RegExp(highlightValue, "g");                 // 強調変換用のRegExp
      let convWord     = highlistTag[0] + highlightValue + highlistTag[1]; // 強調タグを追加した文字列

      if ('searchType' in options && options.searchType === 'match') {
          // 完全一致での検索
          highlightReg = new RegExp(highlightValue + '([\\s])', "g");
          convWord     += '$1';
      }

      $.each(parsedHtml, (idx, elm) => {

          // パースした要素ごとに処理を実施
          if (elm.nodeType !== Node.TEXT_NODE) {

              // テキスト以外の要素は、変換対象外
              retHtml[idx] = elm.outerHTML;
              return true;
          }

          // テキスト要素の中で、強調文字の前後に強調表示タグを追加
          let nodeValue = elm.nodeValue;

          if ('searchType' in options && options.searchType === 'match') {
              nodeValue += '\n';
          }

          retHtml[idx] = nodeValue.replace(highlightReg, convWord);
          nodeValue.replace('\n', '');
      });

      return retHtml.join('');
  };

  /**
   * 文字列に上限値を設定し、それ以降の文字列を指定した文字に置き換える
   *
   * @param {string} value 元の文字列
   * @param {string} tail  変換後の文字列
   * @param {Number} limit 上限値
   */
  self.trimLimit = function(value, tail, limit = 100) {
    if (value.length <= 100) {
      return value;
    }
    return `${value.substring(0, limit)}${tail}`;
  };

  /**
   *
   */
  self.convertTextToArray = function(text) {
    return text
      .trim()
      .split(/\n/)
      .filter(element => element.trim().length > 0);
  };

  /**
   *
   */
  self.toggleModal = function(idName) {
    const id = document.getElementById(idName);

    if (!id) {
      return;
    }

    id.classList.toggle('u-display-none');
  };

  /**
   *
   */
  self.getItemValue = function(obj, key) {
    return key in obj ? obj[key][0] : '';
  };

  /**
   *
   */
  self.getFormattedDate = function(target, diff, formatOut) {
    const curDate = new Date();

    if (!target || !diff || !formatOut) {
      return Moment(curDate).format('YYYY-MM-DD HH:mm');
    }

    const duration = Moment.duration(diff, target);
    return Moment(curDate)
      .add(duration)
      .format(formatOut);
  };

  /**
   * 日付のフォーマット.
   */
  self.formatDatetime = function(date, format) {
    return Moment(date).format(format);
  };

  /**
   * 数値フォーマットの取得.
   *
   */
  self.bigNumberFormat = function(number) {
    if (number < 0) {
      return '0';
    }
    const oneHundredMillion = 100000000;
    const tenThousand       = 10000;
    const decimalUnit       = 10;
    if (Math.floor(number / oneHundredMillion)) {
      return Math.round((number * decimalUnit) / oneHundredMillion) / decimalUnit + '億';
    }
    if (Math.floor(number / tenThousand)) {
      return Math.round((number * decimalUnit) / tenThousand) / decimalUnit + '万';
    }
    return Intl.NumberFormat().format(number);
  };

  /**
   *
   */
  self.toggleMenu = function() {
    if ($('#IncludeSearch').css('display') === 'block') {
      $('#IncludeSearch:not(:animated)').slideUp(1000);
    } else {
      $('#IncludeSearch').slideDown(1000);
    }
    return false;
  };

  /**
   * ローディング画面表示.
   * <pre>
   * ローディング時のモーダル画面を表示させる。
   * </pre>
   */
  self.loading = function() {
    $.blockUI({
      message:
        '<p style="font-weight:bold;font-size:20px;"><img style="vertical-align: middle" src="/snsresearch/img/global/loading.gif"> 検索中・・・・</p>',
      css: {
        border: 'none',
        padding: '3px',
        backgroundColor: '#333',
        opacity: 0.9,
        color: '#fff',
      },
      overlayCSS: {
        backgroundColor: '#000',
        opacity: 0.7,
      },
    });
    setTimeout($.unblockUI, 9990000);
  };

  /**
   * ローディング画面表示（ハイパーリンク）.
   * <pre>
   * ローディング時のモーダル画面を表示させる。
   * ※．以下のいづれかのキーが入力されている場合、ローディング表示を行わない
   *       1. Ctrl
   *       2. Alt
   *       3. Shift
   *       4. meta
   * </pre>
   * @param {event} event イベント
   */
  self.loadingOfLink = function(event) {
    const key_event = event || window.event;

    if (
      key_event.shiftKey ||
      key_event.ctrlKey ||
      key_event.altKey ||
      key_event.metaKey
    ) {
      // 以下のいづれかのキーが入力されている場合、ローディング表示を行わない
      //   1. Ctrl
      //   2. Alt
      //   3. Shift
      //   4. meta
      return;
    }

    self.loading();
  };

  /**
   * 除外キーワードのフォームを作成する
   *
   * @param {string} name テキストボックスのname
   */
  self.addExclusionWordsForm = function(name) {
    const inputForm = document.querySelectorAll(
      '#KeywordSearchExclusionWord .form-group'
    );

    if (inputForm.length >= 5) {
      return;
    }

    const div = document.createElement('div');
    div.setAttribute('class', 'form-group');

    const input = document.createElement('input');
    input.setAttribute('type', 'text');
    input.setAttribute('class', 'o-form__text form-control');
    input.setAttribute('name', name);
    input.setAttribute('placeholder', '除外キーワード入力');
    input.setAttribute('maxlength', 50);
    div.appendChild(input);

    const parent = document.querySelector(
      '#KeywordSearchExclusionWord .form-group'
    );

    parent.parentNode.insertBefore(div, parent.nextElementSibling);
  };

  /**
   * 除外キーワードリストのフォームを作成する
   *
   * @param {string} name セレクトボックスのname
   * @param {object} optionData 除外キーワードリストのデータ
   */
  self.addExclusionWordListForm = function(name, optionData) {
    const form = document.querySelectorAll(
      '#KeywordSearchExclusionKeyWordList .form-group'
    );

    if (form.length >= 5) {
      return;
    }

    const div = document.createElement('div');
    div.setAttribute('class', 'form-group');

    const select = document.createElement('select');
    select.setAttribute('name', name);
    select.setAttribute('class', 'o-button--hoverSelect--add form-control');
    div.appendChild(select);

    const defaultOption = document.createElement('option');
    defaultOption.textContent = 'リストから選択';
    select.appendChild(defaultOption);

    optionData.forEach(data => {
      const option = document.createElement('option');
      option.setAttribute('value', data.keyword_list_id);
      option.textContent = data.keyword_list_name;
      select.appendChild(option);
    });

    const parent = document.querySelector(
      '#KeywordSearchExclusionKeyWordList .form-group:last-of-type'
    );
    parent.parentNode.insertBefore(div, parent.nextElementSibling);
  };

  /**
   * メッセージ等を非表示にする
   */
  self.closeMessage = function() {
    $(this)
      .parent()
      .addClass('u-display-none');
  };

  const sidebarKey = 'sidebar-open';

  /**
   * サイドバーを開閉する
   */
  self.toggleSideBar = function() {
    const newStatus = self.isSidebarClose() ? '1' : '0';
    Cookies.set(sidebarKey, newStatus);

    self.setSidebarClass(newStatus);
  };

  /**
   * サイドバーおよびそれに影響する要素のClassの付け替え
   */
  self.setSidebarClass = function(status) {
    // 開ける
    if (status === '1') {
      // 左のサイドバーの開閉
      document.getElementById('SideLarge').classList.remove('u-display-none');
      document.getElementById('SideSmall').classList.add('u-display-none');

      // メインコンテンツを制御
      Array.from(document.getElementsByClassName('l-content-main')).forEach(
        element => element.classList.add('u-margin-left-content-main')
      );
      Array.from(document.getElementsByClassName('l-content-main')).forEach(
        element => element.classList.remove('u-margin-left-content-main-small')
      );

      // 左のサイドバーを制御
      Array.from(document.getElementsByClassName('l-content-side')).forEach(
        element => element.classList.add('u-width-side-nav-left')
      );
      Array.from(document.getElementsByClassName('l-content-side')).forEach(
        element => element.classList.remove('u-width-side-nav-left-small')
      );

      // サイドメニューを制御
      Array.from(document.getElementsByClassName('l-card-side-nav')).forEach(
        element => element.classList.add('l-card-side-nav__positionLeftLarge')
      );
      Array.from(document.getElementsByClassName('l-card-side-nav')).forEach(
        element =>
          element.classList.remove('l-card-side-nav__positionLeftSmall')
      );

      // ヘッダーを制御
      Array.from(document.getElementsByClassName('head')).forEach(element =>
        element.classList.add('u-width-head')
      );
      Array.from(document.getElementsByClassName('head')).forEach(element =>
        element.classList.remove('u-width-head-small')
      );

      // Tweet検索（キーワード・ハッシュタグ）のフォームの位置を中央に制御
      Array.from(document.getElementsByClassName('l-content-search')).forEach(
        element => element.classList.remove('l-content-search-side-small')
      );

    } else {
      document.getElementById('SideSmall').classList.remove('u-display-none');
      document.getElementById('SideLarge').classList.add('u-display-none');

      Array.from(document.getElementsByClassName('l-content-main')).forEach(
        element => element.classList.add('u-margin-left-content-main-small')
      );
      Array.from(document.getElementsByClassName('l-content-main')).forEach(
        element => element.classList.remove('u-margin-left-content-main')
      );

      Array.from(document.getElementsByClassName('l-content-side')).forEach(
        element => element.classList.add('u-width-side-nav-left-small')
      );
      Array.from(document.getElementsByClassName('l-content-side')).forEach(
        element => element.classList.remove('u-width-side-nav-left')
      );

      Array.from(document.getElementsByClassName('l-card-side-nav')).forEach(
        element => element.classList.add('l-card-side-nav__positionLeftSmall')
      );
      Array.from(document.getElementsByClassName('l-card-side-nav')).forEach(
        element =>
          element.classList.remove('l-card-side-nav__positionLeftLarge')
      );

      Array.from(document.getElementsByClassName('head')).forEach(element =>
        element.classList.add('u-width-head-small')
      );
      Array.from(document.getElementsByClassName('head')).forEach(element =>
        element.classList.remove('u-width-head')
      );

      Array.from(document.getElementsByClassName('head')).forEach(element =>
        element.classList.add('u-width-head-small')
      );
      Array.from(document.getElementsByClassName('head')).forEach(element =>
        element.classList.remove('u-width-head')
      );

      Array.from(document.getElementsByClassName('l-content-search')).forEach(element =>
          element.classList.add('l-content-search-side-small')
      );
    }
  };

  /**
   * サイドバーが閉じているかどうか
   * 0: close
   * 1: open
   */
  self.isSidebarClose = function() {
    return Cookies.get(sidebarKey) === '0';
  };

  /**
   * キーワード入力textareaの高さを自動調整
   */
  self.autoTextareaHeight = function(event) {
    let element = event.target;
    setTimeout(function() {
      element.style.cssText = 'height:auto; padding:0';
      element.style.cssText = 'height:' + element.scrollHeight + 'px';
    }, 0);
  };

  /**
   * 入力済みのテキストボックスに下線を付与する
   */
  $('input').on('change', function() {
    if (this.value !== '') {
      $(this).addClass('o-form__inputValue');
    } else {
      $(this).removeClass('o-form__inputValue');
    }
  });

  /**
   * ログアウトのアコーディオンが開いた場合、クリックをトリガーに閉じる
   */
  $(document).on('click', function(e) {
    if (!$('#logout-form').hasClass('u-display-none')) {
      if (
        !$(e.target).closest('.o-button--moreVert.u-margin-right-normal').length
      ) {
        self.toggleModal('logout-form');
      }
    }
  });

  /**
   * ツールチップ
   *
   * [HTML側の実装方法]
   *  <a class="o-button--tooltip">
   *    <span class="o-tooltipShow">ツールチップに表示させる文言</span>
   *  </a>
   */
  $('a:has(.o-tooltipShow)')
    .mouseover(function() {
      // ?ボタンの幅
      const buttonWidth = $(this).outerWidth();
      // ?ボタンの絶対位置
      const off = $(this).offset();
      // ツールチップをbodyの末尾に追加して、さらに表示させる文言を設定する。
      $('body').append(
        `<div class="o-tooltip u-opacity-0">${$(this)
          .children('.o-tooltipShow')
          .html()}</div>`
      );
      // ツールチップのborder領域を含めたサイズを取得
      const tooltipHeight = $('div.o-tooltip').outerHeight();
      const tooltipWidth = $('div.o-tooltip').outerWidth();
      // ツールチップの表示位置を指定
      $('.o-tooltip:not(:animated)')
        .css({
          top: `${off.top - tooltipHeight - 15}px`,
          left: `${off.left + buttonWidth / 2 - tooltipWidth / 2}px`,
        })
        .removeClass('u-opacity-0');
    })
    .mousemove(function() {
      // <a>タグの機能（ページ遷移）を無効化
      return false;
    })
    .mouseout(function() {
      // bodyの末尾に追加したツールチップを削除
      $('.o-tooltip:not(:animated)').remove();
      return false;
    });

  return self;
})();
